(function() {
  const targetNode = document.querySelector('.header-wishlist-container');

  if (!targetNode) {
    return;
  }

  const config = { childList: true, subtree: true };

  const callback = (mutationList) => {
    for (const mutation of mutationList) {
      if (mutation.target?.classList.contains('kaktus-w-wishlist-counter') && mutation.target.textContent == 0) {
        targetNode.classList.add('hide-counter');
      } else if (mutation.target?.classList.contains('kaktus-w-wishlist-counter')) {
        targetNode.classList.remove('hide-counter');
      }
    }
  };

  const observer = new MutationObserver(callback);

  observer.observe(targetNode, config);
})();
